import { URLS, resolvePublicServiceUrl } from "@itaas/ports";

export const IAM_API_BASE_URL =
  import.meta.env.VITE_IAM_API_BASE_URL ?? "/api/iam";

export const IAM_TENANT_SLUG =
  import.meta.env.VITE_IAM_TENANT_SLUG ?? "demo-hospitol";

export const HOSPITOL_API_BASE_URL =
  import.meta.env.VITE_HOSPITOL_API_BASE_URL ?? "/api/hospitol";

export const SUITE_URL = resolvePublicServiceUrl(
  import.meta.env.VITE_SUITE_URL,
  "VITE_SUITE_URL",
  URLS.SUITE_WEB,
);

export const MODULE_URLS = {
  rh: resolvePublicServiceUrl(
    import.meta.env.VITE_RH_URL,
    "VITE_RH_URL",
    URLS.RH_WEB,
  ),
  inventory: resolvePublicServiceUrl(
    import.meta.env.VITE_INVENTORY_URL,
    "VITE_INVENTORY_URL",
    URLS.INVENTORY_WEB,
  ),
  billing: resolvePublicServiceUrl(
    import.meta.env.VITE_BILLING_URL,
    "VITE_BILLING_URL",
    URLS.BILLING_WEB,
  ),
} as const;

export type IntegratedModuleId = keyof typeof MODULE_URLS;

export function getSuiteLoginUrl(): string {
  return `${SUITE_URL.replace(/\/$/, "")}/login`;
}

export function getSuiteModulesUrl(): string {
  return `${SUITE_URL.replace(/\/$/, "")}/modules`;
}

export function redirectToSuiteLogin(returnPath?: string): void {
  const path =
    returnPath ?? `${window.location.pathname}${window.location.search}`;
  const params = new URLSearchParams({
    module: "hospitol",
    returnTo: path,
  });
  window.location.href = `${getSuiteLoginUrl()}?${params}`;
}

export function getModuleBaseUrl(moduleId: IntegratedModuleId): string {
  return MODULE_URLS[moduleId].replace(/\/$/, "");
}
